import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Star, Quote } from 'lucide-react';

const ProfessionalTestimonials = () => {
  const [expandedCards, setExpandedCards] = React.useState<number[]>([]);

  const toggleExpanded = (index: number) => {
    setExpandedCards(prev => 
      prev.includes(index) 
        ? prev.filter(i => i !== index)
        : [...prev, index]
    );
  };

  const testimonials = [
    {
      name: "Juliana Santos",
      role: "Médica Ginecologista Obstetra",
      image: "/lovable-uploads/c42efeef-6377-470c-a11c-b12fce8a1354.png",
      content: "Com certeza! Agora sei como orientar melhor as minhas pacientes. Achei que sabia bastante sobre amamentação mas seu curso abriu meus olhos para um universo enorme de conhecimento que eu não tinha! Muito obrigada.",
      rating: 5
    },
    {
      name: "Karen Zandoná",
      role: "Odontopediatra",
      image: "/lovable-uploads/d51c8c4a-883f-41bc-ba5f-80f54f117518.png",
      content: "Eu conheci a Rosane por indicação num simpósio sobre amamentação que fiz em 2018. Desde então sigo o trabalho dela e as informações que ela posta nas redes. Com 13 semanas de gestação assisti uma aula no Youtube e comprei o curso dela, que saberia que me auxiliaria tanto para a questão da minha amamentação e a melhorar minhas orientações para as mamães e bebês que atendo no consultório com indicação de alteração de freio lingual. De fato, após ter feito o curso e ter me ajudado com a minha própria filha – que nosso início de amamentação não foi fácil-, minhas consultas estão mais completas, consigo entender e orientar melhor as mães quanto a posição e pega do bebê, tanto antes quanto pós procedimento, e quanto ao uso e riscos de uso de chupeta/mamadeira, e assim sinto que as consultas ficam mais completas.",
      rating: 5
    },
    {
      name: "Lucia Helena da Silva Oliveira",
      role: "Técnica de Enfermagem",
      image: "/lovable-uploads/4d147df6-6ec4-42a7-a733-47205740cb1c.png",
      content: "Eu fiz o seu curso Amamentação de Ouro e é baseado nele que dou minhas palestras, vc é demais 👏👏 sua dinâmica é maravilhosa, super intendivel. Hoje trabalho como técnica de enfermagem no banco de coleta de leite humano e seus ensinamentos me ajudaram muito a me sentir mais segura na fala e na abordagem.",
      rating: 5
    }
  ];

  return (
    <section id="testimonials" data-section="testimonials" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            O Que Dizem os Profissionais Formados
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Depoimentos reais de profissionais que transformaram sua prática 
            com nossa formação especializada
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => {
            const isExpanded = expandedCards.includes(index);
            const shouldTruncate = testimonial.content.length > 200;
            const displayContent = shouldTruncate && !isExpanded 
              ? testimonial.content.substring(0, 200) + "..."
              : testimonial.content;

            return (
              <Card key={index} className="border-none shadow-lg hover:shadow-xl transition-all duration-300 relative overflow-hidden">
                <CardContent className="p-6">
                  <div className="flex items-center gap-4 mb-4">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-20 h-20 rounded-full object-cover border-2 border-primary/10"
                    />
                    <div>
                      <h3 className="font-semibold text-gray-900 text-lg">{testimonial.name}</h3>
                      <p className="text-sm text-primary font-medium">{testimonial.role}</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center gap-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />
                    ))}
                  </div>
                  
                  <p className="text-gray-700 leading-relaxed">
                    "{displayContent}"
                  </p>
                  
                  {shouldTruncate && (
                    <button 
                      onClick={() => toggleExpanded(index)}
                      className="text-primary font-medium text-sm mt-2 py-1 hover:underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 rounded"
                    >
                      {isExpanded ? "Ler menos" : "Ler mais"}
                    </button>
                  )}
                </CardContent>
              </Card>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default ProfessionalTestimonials;